module.exports = __webpack_public_path__ + "static/media/shortinglistup-white.0cac034d.svg";